import { cn } from "@/lib/utils";

/** Input / select natif (base design system Woahda) */
export const inputFieldClass =
  "w-full bg-white border border-[#e4e8ef] rounded-md px-3 py-[7px] text-[13px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-[#1a2744] focus:ring-1 focus:ring-[#1a2744]/20 transition-colors duration-100 disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed";

export const inputFieldErrorClass = "border-red-300 focus:border-red-400 focus:ring-red-400/20";

export const textareaFieldClass = cn(inputFieldClass, "resize-none min-h-[80px]");

const SELECT_CHEVRON =
  "bg-[url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23475569%27 stroke-width=%272%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E')]";

export const selectFieldClass = cn(
  inputFieldClass,
  "appearance-none cursor-pointer bg-no-repeat bg-[length:16px] bg-[right_0.65rem_center] pr-9",
  SELECT_CHEVRON
);

export const formLabelClass =
  "block text-[11px] font-semibold uppercase tracking-[0.06em] text-slate-500 mb-1.5";

export const formFieldErrorTextClass = "text-[11px] text-red-500 mt-1 flex items-center gap-1";

export const formSectionTitleClass =
  "text-[10px] font-bold uppercase tracking-[0.08em] text-slate-400 pb-2 border-b border-[#e4e8ef] mb-3";

export const modalOverlayClass =
  "fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4 backdrop-blur-[2px]";

export const modalPanelClass = "flex w-full max-w-md flex-col rounded-lg border border-[#e4e8ef] bg-white";

export const modalPanelLargeClass = "max-w-xl";

export const drawerOverlayClass = "fixed inset-0 z-40 bg-black/30 backdrop-blur-[2px]";

export function drawerPanelClass(widthPx: number | string): string {
  const w = typeof widthPx === "number" ? `w-[min(100vw,${widthPx}px)]` : widthPx;
  return cn(
    "fixed right-0 top-0 z-50 flex h-full max-w-full flex-col border-l border-[#e4e8ef] bg-white",
    w
  );
}

/** Onglets horizontaux (app-wide Woahda) */
export const formTabsListClass = "flex border-b border-[#e4e8ef]";
export const formTabButtonClass =
  "cursor-pointer border-b-2 border-transparent px-4 py-2 text-[13px] font-medium text-slate-400 -mb-px transition-colors duration-100 hover:text-slate-600";
export const formTabButtonActiveClass = "border-[#1a2744] text-[#1a2744]";
